(() => {
  const pendingEvents = [];
  const sentSuccessKeys = new Set();
  let flushTimer = null;
  let flushAttempts = 0;

  function eventPayload(extra = {}) {
    return {
      page_path: window.location.pathname,
      page_title: document.title,
      ...extra,
    };
  }

  function flushPendingEvents() {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return false;

    while (pendingEvents.length) {
      const event = pendingEvents[0];
      try {
        publish(event.name, event.payload);
        pendingEvents.shift();
      } catch (error) {
        break;
      }
    }

    if (!pendingEvents.length && flushTimer) {
      window.clearInterval(flushTimer);
      flushTimer = null;
      flushAttempts = 0;
    }
    return !pendingEvents.length;
  }

  function scheduleFlush() {
    if (flushPendingEvents() || flushTimer) return;
    flushAttempts = 0;
    flushTimer = window.setInterval(() => {
      flushAttempts += 1;
      if (flushPendingEvents() || flushAttempts >= 40) {
        window.clearInterval(flushTimer);
        flushTimer = null;
        flushAttempts = 0;
      }
    }, 250);
  }

  function publish(name, extra = {}) {
    const eventName = `bbc:${name}`;
    const payload = eventPayload(extra);
    pendingEvents.push({ name: eventName, payload });
    scheduleFlush();
    window.dispatchEvent(new CustomEvent('bbc:conversion-event', {
      detail: { name: eventName, payload },
    }));
  }

  function readyStockCategoryName(link) {
    const pathname = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
    const categories = {
      '/collections/folding-boxes': 'Foldable Rigid Gift Boxes',
      '/collections/jewelry-boxes': 'Ready-Stock Jewelry Boxes',
      '/collections/pen-boxes': 'Ready-Stock Pen Gift Boxes',
      '/products/gift-box-filler-shredded-paper-eco-friendly': 'Gift Box Filler',
    };
    return categories[pathname] || '';
  }

  function trackSuccessfulContactForm(root = document) {
    const selector = '#ContactForm .form__message, #ContactForm .form-status-list.form__message';
    const success = root.matches?.(selector) ? root : root.querySelector?.(selector);
    if (!success) return;
    const key = `${window.location.pathname}:contact_form_success`;
    if (sentSuccessKeys.has(key) || sessionStorage.getItem(key)) return;
    sentSuccessKeys.add(key);
    sessionStorage.setItem(key, '1');
    publish('generate_lead', {
      form_id: 'ContactForm',
      lead_type: 'contact_form',
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const label = (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);

    if (/wa\.me\/8613388450055/i.test(href)) {
      publish('whatsapp_click', {
        contact_method: 'whatsapp',
        link_text: label || 'WhatsApp',
      });
      return;
    }

    if (/^mailto:/i.test(href)) {
      publish('email_click', {
        contact_method: 'email',
        link_text: 'Email',
      });
      return;
    }

    const readyStockCategory = link.closest('.bbc-ready-category');
    const categoryName = readyStockCategory
      ? readyStockCategory.querySelector('h3')?.textContent?.replace(/\s+/g, ' ').trim().slice(0, 80)
      : readyStockCategoryName(link);
    if (categoryName) {
      publish('ready_stock_category_click', {
        category_name: categoryName,
        link_url: href,
      });
      return;
    }

    if (
      href.includes('/pages/contact')
      || href.includes('/pages/custom-packaging')
      || href.includes('/products/custom-gift-box-design-manufacturing-service')
      || /request (a )?(custom )?quote|start (your )?(custom )?project/i.test(label)
    ) {
      publish('quote_cta_click', {
        link_url: href,
        link_text: label || 'Request a Quote',
      });
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target?.id === 'ContactForm-sample' && event.target.checked) {
      publish('sample_request_selected', { form_id: 'ContactForm' });
    }
  });

  document.addEventListener('submit', (event) => {
    if (event.target?.id === 'ContactForm') {
      publish('lead_form_submit', { form_id: 'ContactForm' });
    }
  });

  window.addEventListener('load', scheduleFlush);
  document.addEventListener('DOMContentLoaded', () => {
    scheduleFlush();
    trackSuccessfulContactForm();
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) trackSuccessfulContactForm(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
